import { render, staticRenderFns } from "./refund_void_switch.vue?vue&type=template&id=66084060&"
import script from "./refund_void_switch.vue?vue&type=script&lang=js&"
export * from "./refund_void_switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports